<template>
  <div class="card-list">
    <div class="row">
      <div
        class="col-md-12"
        :class="{ 'col-md-6': cards.length > 1 }"
        v-for="card in cards"
        :key="card.id"
      >
        <div class="z-card z-card--small spacer-bottom-st card-wrapper">
          <z-icon :icon="['fal', 'times']" size="medium" class="remove__card-icon" @click="openModal(card)" />
          <card-details :card="card" />
          <button class="z-button z-button--primary z-button--block" @click="selectCard(card)">
            Pagar com este cartão
          </button>
        </div>
      </div>

      <z-modal :open="confirmModalOpen" @closed="closeModal()">
        <div class="z-title z-title--small spacer-bottom-s">
          Remover cartão
        </div>

        <div class="z-text spacer-bottom-m">
          Tem certeza que deseja remover este cartão?
        </div>

        <card-details :card="cardToRemove" />

        <div class="z-button-wrapper">
          <button class="z-button z-button--block z-button--danger" @click="removeCard">
            Sim
          </button>

          <button class="z-button z-button--block z-button--secondary" @click="closeModal">
            Não
          </button>
        </div>
      </z-modal>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-wrapper {
  position: relative;
}

.remove__card-icon {
  cursor: pointer;
  position: absolute;
  right: var(--space-medium);
}
</style>

<script>
import CardService from 'services/CardService';
import CardDetails from './card-details';

export default {
  data() {
    return {
      cardToRemove: {},
      confirmModalOpen: false,
    };
  },
  props: {
    cards: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    CardDetails,
  },
  methods: {
    selectCard(card) {
      this.$emit('cardSelected', card);
    },
    removeCard() {
      CardService.removeCard(this.cardToRemove.id)
        .then(() => {
          this.closeModal();
          return this.$emit('cardRemoved', this.cardToRemove);
        });
    },
    openModal(card) {
      this.cardToRemove = card;
      this.confirmModalOpen = true;
    },
    closeModal() {
      this.confirmModalOpen = false;
    },
  },
};
</script>
